import { render } from "./JobDetailPage.vue?vue&type=template&id=207c5870&scoped=true"
import script from "./JobDetailPage.vue?vue&type=script&lang=js"
export * from "./JobDetailPage.vue?vue&type=script&lang=js"

import "./JobDetailPage.vue?vue&type=style&index=0&id=207c5870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207c5870"]])

export default __exports__